export const zone_all = { value: '', label: 'ทั่วประเทศ' }
export const province_all = { value: '', label: 'ทุกจังหวัดในเขตสุขภาพ' }
export const hospital_all = { value: '', label: 'ทุกโรงพยาบาลในจังหวัด' }
export const zone_query_str = 'listzone'
export const province_query_str = 'listprovincebyzone'
export const hospital_query_str = 'listhosbyprovince'

export const path = {
    all: '/:viewtype/:start/:end',
    zone: '/:viewtype/:start/:end/:zone',
    province: '/:viewtype/:start/:end/:zone/:province',
    hospital: '/:viewtype/:start/:end/:zone/:province/:hospital',
}

export const chart_query_str_dictionary = {
    all: { timeline: 'countclassgroupbytime', pie: 'countclassgroupbyzone' },
    zone: { timeline: 'countclassbyzonegroupbytime', pie: 'countclassbyzonegroupbyprovince' },
    province: { timeline: 'countclassbyprovincegroupbytime', pie: 'countclassbyprovincegroupbyhos' },
    hospital: { timeline: 'countclassbyhosgroupbytime' },
};

export const viewtypes = [
    { value: 'W', label: 'Week' },
    { value: 'M', label: 'Month', default: true },
    { value: 'Q', label: 'Quarter' },
    { value: 'Y', label: 'Year' }
]
export const yAxisTitle = 'Films';
export const gridLinesAmount = 5

export const ZOOM = [
    { id: '-', zoom: [0.04, 1250, 3900], },
    { id: 'เขตสุขภาพที่ 1', zoom: [0.23, -20, -1000], },
    { id: 'เขตสุขภาพที่ 2', zoom: [0.23, 400, 900], },
    { id: 'เขตสุขภาพที่ 3', zoom: [0.14, 500, 2000], },
    { id: 'เขตสุขภาพที่ 4', zoom: [0.13, 1300, 3100], },
    { id: 'เขตสุขภาพที่ 5', zoom: [0.35, -20, 4300], },
    { id: 'เขตสุขภาพที่ 6', zoom: [0.2, 2000, 4300], },
    { id: 'เขตสุขภาพที่ 7', zoom: [0.17, 3200, 1500], },
    { id: 'เขตสุขภาพที่ 8', zoom: [0.23, 3100, 100], },
    { id: 'เขตสุขภาพที่ 9', zoom: [0.19, 3000, 2300], },
    { id: 'เขตสุขภาพที่ 10', zoom: [0.19, 4700, 2100], },
    { id: 'เขตสุขภาพที่ 11', zoom: [0.25, -10, 8100], },
    { id: 'เขตสุขภาพที่ 12', zoom: [0.2, 1200, 10000], }
]